export default __webpack_public_path__ + "static/media/SourceSansPro-SemiBold.623603c2.ttf";